<div class='max-user-commercial-contact'>
  <span>{{ 'Besoin de plus de $nb$ utilisateurs ?' | transloco: { nb: maxUsers } }}</span>
  <a href='https://infomaniak.com/gtl/commercial-contact'
     rel='noopener noreferrer'
     target='_blank'
  >{{ 'Contactez notre service commercial' | transloco }}</a>
</div>